export const TERMS_OF_USE = 'https://medicalhomenetwork.org/mhnconnect-terms-of-use';
export const PRIVACY_POLICY = 'https://medicalhomenetwork.org/mhnconnect-privacy-policy';
export const POLICIES_AND_PROCEDURES = 'https://medicalhomenetwork.org/mhnconnect-policies-and-procedures';
export const COMPLIANCE = 'https://medicalhomenetwork.org/compliance';
